<template>
  <div class="text" :style="{color:fontColor}">No Data</div>
</template>

<script>
export default {
  name: 'NoDataText',
  props:{
  fontColor: {
      type: String,
      default () {
        return "#555"
      }
  }
  }

}
</script>

<style scoped>
.text {
  text-align: center;
  /* opacity: 0.58; */
  font-size: 20px;
  /* color: #0C0C0C; */
  letter-spacing: -0.4px;
  font-weight: 400;
}
</style>
